export const getDate = (date: string) => {
    const selectetDate = new Date(date);
    const day = selectetDate.getDate() <= 9 ? `0${selectetDate.getDate()}` : selectetDate.getDate();
    const month = selectetDate.getMonth() + 1 <= 9 ? `0${selectetDate.getMonth() + 1}` : selectetDate.getMonth();
    const year = selectetDate.getFullYear();
    const hour = selectetDate.getHours() <= 9 ? `0${selectetDate.getHours() + 0}` : selectetDate.getHours();
    const minutes = selectetDate.getMinutes() <= 9 ? `0${selectetDate.getMinutes() + 0}` : selectetDate.getMinutes();
    return `${day}.${month}.${year} ${hour}:${minutes}`
}

export const maxDate = () => {
    const date = new Date();
    date.setFullYear(date.getFullYear() + 10);
    const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
    const month = date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth();
    const year = date.getFullYear();
    return `${day}-${month}-${year}T00:00`
}

export const minDate = () => {
    const date = new Date();
    date.setDate(date.getDate());
    const day = date.getDate() <= 9 ? `0${date.getDate()}` : date.getDate();
    const month = date.getMonth() + 1 <= 9 ? `0${date.getMonth() + 1}` : date.getMonth();
    const year = date.getFullYear();
    return `${day}-${month}-${year}T00:00`
}